import { Component, OnInit, OnDestroy } from '@angular/core';
import { ObservatoryService } from '@services/services.module';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})

export class MessagesComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription> = [];
  messagesData: MessageData = new MessageData();

  constructor(
    private observatory: ObservatoryService
  ) { }

  ngOnInit() {
    this.subscriptions.push(
      this.observatory.getData('messagesData').subscribe((data) => {
        if (data){
          this.messagesData = data;
          setTimeout(() => {
            this.messagesData.type = 'vacio';
            this.messagesData.message = '';
          }, 7000);
        }
      })
    );
  }

  /**
   * @name ngOnDestroy
   * @description Lifecycle hook
   */
  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }
}

export class MessageData {
  type: string;
  message: string;
  show: boolean;
}